import React, { useRef, useEffect, useState } from "react";
import { Card, CardActionArea } from "@material-ui/core";
import Webcam from "react-webcam";
import { runBlazeFace, stopBlazeFace, drawRef, clearRef, loadBlazeFaceModel } from "../../api/BlazeFace";
import { useVideo } from "../../api/VideoProvider";
import { pRecordVideo, pWebcam, pVideoConstraints, pVideoConstraintsPortrait, pRecordVideoPortrait, pVideoConstraintsSquare, pRecordVideoSquare, pStatus } from "../../utils/parameters";
import { useReactMediaRecorder } from "react-media-recorder";
import { CountdownTimer } from "../../components/home/CountdownTimer";
import { RecordingChip } from "./RecordingChip";
import Tooltip from '@mui/material/Tooltip';
import imgIdeal_0 from "../../assets/icons/sig_IdealFrame_0b.png";
import imgIdeal_1 from "../../assets/icons/sig_IdealFrame_1b.png";
import { VisualControl, btns_home_positions_arr_default } from './VisualControl';
import { FPSInfoChip } from './FPSInfoChip';
import { useMediapipe } from '../../api/MediapipeHolistic';
import { useVirtualBG } from '../../api/VirtualBG';
import logoBlue from "../../assets/logos/logo-blue-square.jpg";
import { useTranslation } from "react-i18next";
import { SubmissionBannerV2 } from "../search/SubmissionBanner_v2";

export function WebcamCardMediapipe(props) {
  const { children, devicePortrait, desktop, setMediaBlobUrl_rec, permissions, deviceId,  switchGalibo, switchMediapipe, switchVirtualBG, blurSettings, setMediapipeData, switchVisualControl, setVisualControlAction, offset } = props;
  const { t } = useTranslation("global")

  /* Video */
  const { startRecording, stopRecording, status, mediaBlobUrl } = useReactMediaRecorder(devicePortrait ? { ...pRecordVideoPortrait, video:{ ...pRecordVideoPortrait.video, deviceId: {exact: deviceId} } } : { ...pRecordVideo, video:{ ...pRecordVideo.video, deviceId: {exact: deviceId} } });
  const { setFaceStatus, faceStatus } = useVideo();
  const [ videoFeedAspectRatio, setVideoFeedAspectRatio ] = useState();
  const [ forceAspect, setForceAspect ] = useState(false);

  /* Refs */
  const blazeFacecanvasRef = useRef(null);
  const mediapipeCanvasRef = useRef(null);
  const virtualBGCanvasRef = useRef(null);
  const webcamRef = useRef(null);

  const { start_Mediapipe, stop_Mediapipe, out_Mediapipe, mediapipe_obtain_output, mediapipe_recorder, mediapipe_getFPS, setShowPose } = useMediapipe();
  const { segmentBackground, applyBlur, applyImageBackground, changeForegroundType, startVirtualBG, stopVirtualBG} = useVirtualBG();

  const [mediapipeFPS, setmediapipeFPS] = useState(0);

  const [zIndexVideo, setZIndexVideo] = useState(5);
  const stepZIndez_Canvas = 3;
  const stepZVideo_Rep = 2;

  const [zIndexCanvas, setZIndexCanvas] = useState(6);
  const [zIndexVideo_Rep, setZIndexVideo_Rep] = useState(1);
  const [timerId, setTimerId] = useState(null);

  /* Blazeface runs only in the webcam mode (not during the repetition) */
  /* Also, it starts running after hitting the 'record' button */
  useEffect(() => {
      
    // console.log("🚀 ~ file: WebcamCardMediapipe.js:56 ~ useEffect ~ faceStatus:", faceStatus)
    
    switch (faceStatus) {
      
      case pStatus.runTf:
        if (webcamRef.current !== null) {
          /* run face engine and show galibo */
          runBlazeFace(webcamRef.current.video, blazeFacecanvasRef.current, setFaceStatus);
          drawRef(webcamRef.current.video, blazeFacecanvasRef.current);
          setFaceStatus(pStatus.faceDetected);
        }
        break;
      case pStatus.init:
        setShowPose(true)
        // console.log('INIT')
        setMediaBlobUrl_rec(null)
        setZIndexVideo_Rep ( zIndexVideo - stepZVideo_Rep)
        setZIndexCanvas ( zIndexVideo + stepZIndez_Canvas)
        // console.log('change z index canvas: '+zIndexCanvas)
        if (webcamRef.current !== null) {
          if (switchMediapipe === true){
            start_Mediapipe(webcamRef.current.video, mediapipeCanvasRef.current);
          }else{
            stop_Mediapipe()
          }
          }
        break;
      case pStatus.countdown:
        stopBlazeFace();
        // setZIndexCanvas ( zIndexVideo - stepZIndez_Canvas)
        if (!offset) startRecording();
        break;
      case pStatus.record:
        // startRecording();
        // stopRecording();
        if (!offset) stopRecording();
        if (!offset) startRecording();
        mediapipe_recorder(true);
        break;
      case pStatus.rep:
        setShowPose(false)
        setZIndexCanvas ( zIndexVideo + stepZIndez_Canvas)
        setZIndexVideo_Rep ( zIndexVideo + stepZVideo_Rep)

        mediapipe_recorder(false);
        mediapipe_obtain_output(setMediapipeData);
        stopRecording();
        break;
      default:
        break;
    }
    // eslint-disable-next-line
  }, [faceStatus, switchMediapipe]);

  /* Detect when the video is ready */
  useEffect(() => {
    if (mediaBlobUrl !== null) {
      setMediaBlobUrl_rec(mediaBlobUrl);
    }
  }, [mediaBlobUrl]);

  /* Unmounted component */
  useEffect(() => {
    loadBlazeFaceModel();
    return () => {
      stopBlazeFace();
    };
  }, []);
    
  /* Adapt to Camera Aspect Ratio */
   useEffect(() => {
    /* This extra step is needed in case a camera doesn't return the desired aspect ratio based on videoConstraints, which happens often... */
    handleGetAspect();
  }, [deviceId, devicePortrait]);

  function handleGetAspect() {
    if (webcamRef.current !== null) {
      const newAspect = webcamRef.current.video.offsetWidth / webcamRef.current.video.offsetHeight;
      console.log(`
      DeviceId: ${deviceId} 
      DevicePortrait: ${devicePortrait} 
      newAspect: ${newAspect}
      videoFeedAspectRatio: ${videoFeedAspectRatio} 
      VideoWidth: ${webcamRef.current.video.offsetWidth} 
      VideoHeight: ${webcamRef.current.video.offsetHeight} 
      `);
      setVideoFeedAspectRatio(newAspect);
      /*if (newAspect > 1){
        setVideoFeedAspectRatio(newAspect);
      }else{
        setVideoFeedAspectRatio(1);
      }*/
      if (devicePortrait) {
        setForceAspect(newAspect > 1); //Device in Portrait, Camera in Landscape
      } else if (newAspect !== 1) {
        setForceAspect(newAspect < 1); //Device in Landscape, Camera in Portrait
      }      
      console.log(webcamRef.current)
    }
  }  
    
  function handleOnUserMedia() {
    if (timerId) {
      clearTimeout(timerId); // Clear the previous timer if it exists
    }

    const newTimerId = setTimeout(() => {
      handleGetAspect();
    }, 200);

    setTimerId(newTimerId); // Set the new timer ID
  }


  function showFPS(){
    const counter_fps = mediapipe_getFPS(true);
    //console.log('value: '+counter_fps)
    setmediapipeFPS(counter_fps[0])
  }

  useEffect(() => {
    const interval = setInterval(() => {
        showFPS();
    }, 1000);
    return () =>{
        console.log('out webcam home')
        clearInterval(interval)
        out_Mediapipe()
        if (timerId) {
          clearTimeout(timerId); // Clear the timer when the component unmounts
        }
    }
  }, []);

  // useEffect(() => {
  //     console.log('Change switchVisualControl: '+switchVisualControl)
  // }, [switchVisualControl]); 


  useEffect(()=>{
    console.log("🚀 ~ file: WebcamCardMediapipe.js:98 ~ WebcamCardMediapipe ~ switchVirtualBG:", switchVirtualBG)
    if (webcamRef.current !== null) {
      if (switchVirtualBG === true){
        segmentBackground(webcamRef.current.video, virtualBGCanvasRef.current);
        startVirtualBG()
      }else{
        stopVirtualBG(virtualBGCanvasRef.current)
      }
    }
  }, [switchVirtualBG]);

  useEffect(()=>{
    // console.log('CONFIGURE BLUR SETTING -  DETECTED CHANGES', blurSettings)

    if (switchVirtualBG === true){
      applyBlur(blurSettings['blur'])
      if (blurSettings['image'] === true){
        // console.log('CONFIGURE BLUR SETTING -  IMAGE')
        const image = new Image();
        image.src = logoBlue
        applyImageBackground(image);
      }
    }
  }, [switchVirtualBG, blurSettings]);
  

  /* STATES :
   * before recording: webcam and canvas
   * recording: only webcam
   * repetition: video in loop
   */
  return (
    <>
      <Card data-tour='tourCam_7' className={`sig_Home_Camera_Root ${props.deviceLarge ? "" : "sig_Home_Camera_Root_LargeDevice"}`}>
        <CardActionArea>
          <FPSInfoChip style= {{top: '50px'}} mediapipeFPS={mediapipeFPS}></FPSInfoChip>

          {permissions && 
              <Webcam 
              className={`sig_Home_Camera_Canvas sig_Home_Camera_Feed ${videoFeedAspectRatio < 1 ? 'sig_Home_Camera_Portrait' : `${videoFeedAspectRatio === 1 ? 'sig_Home_Camera_Square' : 'sig_Home_Camera_Landscape'}`}${forceAspect ? 'Forced' : ''}`} 
              ref={webcamRef} 
              audio={pWebcam.audio} 
              mirrored={pWebcam.mirrored} 
              screenshotFormat="image/jpeg" 
              videoConstraints={devicePortrait ? { ...pVideoConstraintsPortrait, deviceId: {exact: deviceId} } 
                                : { ...pVideoConstraints, deviceId: {exact: deviceId} } } 
              style={{ zIndex: zIndexVideo, audio: false }} 
              onUserMedia={handleOnUserMedia}/>}

          {faceStatus !== pStatus.rep ? (
            <>
              <div className="sig_Home_Camera_Canvas_BorderTop"></div>
              <div className="sig_Home_Camera_Canvas_BorderBottom"></div>
              
              {faceStatus === pStatus.record ? (
                <></>
              ) : (
                <>
                  {/* <canvas className="sig_Home_Camera_Canvas sig_Home_Camera_FaceStatus" ref={canvasRef} style={{ zIndex: zIndexCanvas, transform: "scaleX(-1)" }} />
                  <canvas className="sig_Home_Camera_Canvas sig_Home_Camera_FaceStatusAux" ref={auxCanvasRef} style={{ zIndex: zIndexCanvas }} /> */}

                  <canvas 
                  className={`sig_Home_Camera_Canvas sig_Home_Camera_FaceStatus ${videoFeedAspectRatio < 1 ? 'sig_Home_Camera_Portrait' : `${videoFeedAspectRatio === 1 ? 'sig_Home_Camera_Square' : 'sig_Home_Camera_Landscape'}`}${forceAspect ? 'Forced' : ''}`} 
                  ref={blazeFacecanvasRef} 
                  style={{ 
                    width: videoFeedAspectRatio > 1 ? webcamRef.current.video.offsetWidth : `${desktop ? 'calc(100% - 20px)' : '100%'}`, 
                    height: videoFeedAspectRatio < 1 ? webcamRef.current.video.offsetHeight : `${desktop ? 'calc(100% - 20px)' : '100%'}`,
                    zIndex: zIndexCanvas, 
                    transform: "scaleX(-1)" 
                    }} />
                  {/* <canvas className={`sig_Home_Camera_Canvas sig_Home_Camera_FaceStatus ${devicePortrait ? 'sig_Home_Camera_Portrait' : 'sig_Home_Camera_Landscape'}${forceAspect ? 'Forced' : ''}`} ref={mediapipeCanvasRef} style={{ zIndex: zIndexCanvas, transform: "scaleX(-1)" }} /> */}
                </>
              )}
            </>
          ) : ( 
            /* The repetition is mirrored (flipped) style={{transform: 'scaleX(-1)' }}*/
            <video 
            className={`sig_Home_Camera_Canvas sig_Home_Camera_Feed ${videoFeedAspectRatio < 1 ? 'sig_Home_Camera_Portrait' : `${videoFeedAspectRatio === 1 ? 'sig_Home_Camera_Square' : 'sig_Home_Camera_Landscape'}`}${forceAspect ? 'Forced' : ''}`} 
            src={mediaBlobUrl} style={{ zIndex: zIndexVideo_Rep }} 
            autoPlay 
            loop />

            // <video src={mediaBlobUrl} style={{ zIndex: zIndexVideo_Rep }} autoPlay loop />
            

          )}
          <canvas 
            className={`sig_Home_Camera_Canvas sig_Home_Camera_FaceStatus ${videoFeedAspectRatio < 1 ? 'sig_Home_Camera_Portrait' : `${videoFeedAspectRatio === 1 ? 'sig_Home_Camera_Square' : 'sig_Home_Camera_Landscape'}`}${forceAspect ? 'Forced' : ''}`} 
            ref={mediapipeCanvasRef} 
            style={{ 
              width: videoFeedAspectRatio > 1 ? webcamRef.current.video.offsetWidth : `${desktop ? 'calc(100% - 20px)' : '100%'}`, 
              height: videoFeedAspectRatio < 1 ? webcamRef.current.video.offsetHeight : `${desktop ? 'calc(100% - 20px)' : '100%'}`,
              zIndex: zIndexCanvas, 
              transform: "scaleX(-1)" 
              }} />

          <canvas 
            className={`sig_Home_Camera_Canvas sig_Home_Camera_FaceStatus ${videoFeedAspectRatio < 1 ? 'sig_Home_Camera_Portrait' : `${videoFeedAspectRatio === 1 ? 'sig_Home_Camera_Square' : 'sig_Home_Camera_Landscape'}`}${forceAspect ? 'Forced' : ''}`} 
            ref={virtualBGCanvasRef} 
            style={{ 
              width: videoFeedAspectRatio > 1 ? webcamRef.current.video.offsetWidth : `${desktop ? 'calc(100% - 20px)' : '100%'}`, 
              height: videoFeedAspectRatio < 1 ? webcamRef.current.video.offsetHeight : `${desktop ? 'calc(100% - 20px)' : '100%'}`,
              zIndex: zIndexCanvas, 
              transform: "scaleX(-1)" 
              }} />

          {children}
        </CardActionArea>
        <CountdownTimer offset={offset} startRecording={startRecording}/>
        {switchVisualControl === true
          ? <VisualControl videoref={webcamRef} setVisualControlAction={setVisualControlAction} btns_arr={btns_home_positions_arr_default}/>
          : <RecordingChip status={status} />
        } 

        { switchGalibo ? 
          <>
            <Tooltip title= {t("sRecordComponent.framing_advice")} placement="top" arrow>
              <div className="sig_Home_FramingContainer">
                <img className={'sig_Home_Framing_Back'} src={imgIdeal_0} alt={t("sRecordComponent.framing_advice")}/> 
                <img className={'sig_Home_Framing_Front'} src={imgIdeal_1} alt={t("sRecordComponent.framing_advice")}/> 
              </div>
            </Tooltip>
          </> 
          : 
          <>
          </>
        }          
        {!switchVisualControl && <SubmissionBannerV2 desktop={desktop} origin={'/camera'}/>}
      </Card>
    </>
  );
}
